var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Picker',{attrs:{"data":_vm.emojiIndex,"native":true,"show-preview":false,"show-search":true,"i18n":_vm.i18n,"emoji-size":20,"set":"google","sheetsize":16},on:{"select":_vm.addEmoji}})
}
var staticRenderFns = []

export { render, staticRenderFns }